import { useCallback, useEffect, useRef, useState } from "react";
import { CalendarMonth, Edit } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Fade,
  Tooltip,
  Typography,
} from "@mui/material";

import {
  PageHeader,
  TrainingDueDateModal,
  TrainingItem,
  TrainingModal,
} from "../../components";
import { ITrainingModalMethods } from "../../components/training-modal";
import { CURRENT_WEEK_DAY, WEEK_DAYS } from "../../@data";
import { useAuth, useTraining } from "../../contexts";
import * as s from "./styles";
import { ITrainingDueDateModalMethods } from "../../components/training-due-date-modal";
import { format } from "date-fns";

const Training = () => {
  const { isVisitant } = useAuth();
  const { training, loadingTraining } = useTraining();
  const [selectedDay, setSelectedDay] = useState<string>(CURRENT_WEEK_DAY.key);
  const [tooltipIsVisible, setTooltipIsVisible] = useState(true);

  const trainingModalRef = useRef<ITrainingModalMethods | null>(null);
  const dueDateModalRef = useRef<ITrainingDueDateModalMethods | null>(null);

  const handleSelectDay = useCallback((newDay: string) => {
    setSelectedDay(newDay);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setTooltipIsVisible(false);
    }, 3000);
  }, []);

  const selectedDayTraining = training?.[selectedDay as never]
    ? Object.entries(training?.[selectedDay as never]).map(
        ([trainingType, description]) => ({ trainingType, description })
      )
    : [];

  return (
    <>
      <TrainingModal ref={trainingModalRef} />
      <TrainingDueDateModal ref={dueDateModalRef} />
      <Fade in timeout={1000}>
        <s.PageContainer>
          <PageHeader
            label={
              training?.teacher ? (
                <Typography sx={{ mt: "-0.5rem" }}>
                  Treinos
                  <Typography
                    sx={{ fontSize: "12px", mt: "-4px" }}
                    color={"gray"}
                  >
                    Prof. {training.teacher}
                  </Typography>
                </Typography>
              ) : (
                "Treinos"
              )
            }
          >
            <Button
              color="inherit"
              size="small"
              sx={{
                height: 40,
                opacity: 0.8,
                ml: "auto",
                mr: "1.8rem",
              }}
              onClick={() => dueDateModalRef?.current?.handleOpen()}
            >
              <CalendarMonth sx={{ height: "1rem", mt: "-2px" }} />
              {training?.trainingDueDate
                ? format(new Date(training.trainingDueDate), "dd/MM/yyyy")
                : "--/--/----"}
            </Button>
          </PageHeader>
          <s.TrainingContainer>
            <Typography>Dias da semana</Typography>
            <section>
              {WEEK_DAYS.map((day) => (
                <Button
                  variant={selectedDay === day.key ? "outlined" : "contained"}
                  onClick={() => handleSelectDay(day.key)}
                  size="small"
                  key={day.key}
                  disabled={isVisitant}
                >
                  {day.label}
                </Button>
              ))}
            </section>
            {loadingTraining ? (
              <CircularProgress sx={{ m: "auto" }} size={30} />
            ) : selectedDayTraining.length ? (
              selectedDayTraining.map((item) => (
                <TrainingItem
                  key={item.trainingType}
                  item={item as never}
                  selectedDay={selectedDay}
                  handleEdit={() =>
                    trainingModalRef.current?.handleOpen(item as never)
                  }
                />
              ))
            ) : isVisitant ? (
              <Typography sx={{ m: "auto", textAlign: "center", opacity: 0.5 }}>
                Apenas clientes podem registrar seus treinos. Entre em contato
                com alguma unidade Arena para se tornar cliente.
              </Typography>
            ) : (
              <Typography sx={{ m: "auto", textAlign: "center", opacity: 0.5 }}>
                Você ainda não possui treinos
                <br />
                cadastrados neste dia.
              </Typography>
            )}
          </s.TrainingContainer>
          <Tooltip
            title={`Editar treino`}
            placement="top-end"
            arrow
            open={tooltipIsVisible}
          >
            <s.EditTrainingButton
              disabled={isVisitant}
              color="primary"
              variant="circular"
              onClick={() => trainingModalRef.current?.handleOpen()}
            >
              <Edit />
            </s.EditTrainingButton>
          </Tooltip>
        </s.PageContainer>
      </Fade>
    </>
  );
};

export default Training;
